var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{attrs:{"type":"submit","variant":"primary","disabled":_vm.disabled}},[(_vm.disabled)?_c('b-spinner',{staticStyle:{"vertical-align":"middle"},attrs:{"small":""}}):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }